import { RangeLinkUI } from "./RangeLinkUI";
import { StandardProps } from "../componentMap";

export function RangeLink({ product }: Pick<StandardProps, "product">) {
  const [set] = product.sets;
  if (!set) return null;

  return <RangeLinkUI setUrl={set.url} setTitle={set.title} />;
}
